import e, { OPTIONS as L } from "../../managers/braze-instance.js";
import X from "../../util/browser-detector.js";
import {
  clickElement as Et,
  supportsPassive as Tt,
} from "../../util/dom-utils.js";
import { KeyCodes as lt } from "../../util/key-codes.js";
import T from "../../managers/subscription-manager.js";
import { isIFrame as It } from "../utils/in-app-message-utils.js";
export default class InAppMessage {
  constructor(
    t,
    s,
    i,
    h,
    e,
    E,
    n,
    o,
    r,
    l,
    u,
    a,
    I,
    c,
    A,
    O,
    _,
    m,
    L,
    N,
    S,
    R,
    M,
    D,
    C,
    d,
    U,
    b,
    P,
    p,
  ) {
    (this.message = t),
      (this.messageAlignment = s),
      (this.slideFrom = i),
      (this.extras = h),
      (this.triggerId = e),
      (this.clickAction = E),
      (this.uri = n),
      (this.openTarget = o),
      (this.dismissType = r),
      (this.duration = l),
      (this.icon = u),
      (this.imageUrl = a),
      (this.imageStyle = I),
      (this.iconColor = c),
      (this.iconBackgroundColor = A),
      (this.backgroundColor = O),
      (this.textColor = _),
      (this.closeButtonColor = m),
      (this.animateIn = L),
      (this.animateOut = N),
      (this.header = S),
      (this.headerAlignment = R),
      (this.headerTextColor = M),
      (this.frameColor = D),
      (this.buttons = C),
      (this.cropType = d),
      (this.orientation = U),
      (this.htmlId = b),
      (this.css = P),
      (this.messageExtras = p),
      (this.message = t),
      (this.messageAlignment = s || InAppMessage.TextAlignment.CENTER),
      (this.duration = l || 5e3),
      (this.slideFrom = i || InAppMessage.SlideFrom.BOTTOM),
      (this.extras = h || {}),
      (this.triggerId = e),
      (this.clickAction = E || InAppMessage.ClickAction.NONE),
      (this.uri = n),
      (this.openTarget = o || InAppMessage.OpenTarget.NONE),
      (this.dismissType = r || InAppMessage.DismissType.AUTO_DISMISS),
      (this.icon = u),
      (this.imageUrl = a),
      (this.imageStyle = I || InAppMessage.ImageStyle.TOP),
      (this.iconColor = c || InAppMessage.th.ih),
      (this.iconBackgroundColor = A || InAppMessage.th.sh),
      (this.backgroundColor = O || InAppMessage.th.ih),
      (this.textColor = _ || InAppMessage.th.hh),
      (this.closeButtonColor = m || InAppMessage.th.eh),
      (this.animateIn = L),
      null == this.animateIn && (this.animateIn = !0),
      (this.animateOut = N),
      null == this.animateOut && (this.animateOut = !0),
      (this.header = S),
      (this.headerAlignment = R || InAppMessage.TextAlignment.CENTER),
      (this.headerTextColor = M || InAppMessage.th.hh),
      (this.frameColor = D || InAppMessage.th.Eh),
      (this.buttons = C || []),
      (this.cropType = d || InAppMessage.CropType.FIT_CENTER),
      (this.orientation = U),
      (this.htmlId = b),
      (this.css = P),
      (this.isControl = !1),
      (this.messageExtras = p),
      (this.nh = !1),
      (this.Th = !1),
      (this.vo = !1),
      (this.oh = !1),
      (this.Me = null),
      (this.ke = null),
      (this.Et = new T()),
      (this.rh = new T()),
      (this.De = InAppMessage.TextAlignment.CENTER);
  }
  subscribeToClickedEvent(t) {
    return this.Et.It(t);
  }
  subscribeToDismissedEvent(t) {
    return this.rh.It(t);
  }
  removeSubscription(t) {
    this.Et.removeSubscription(t), this.rh.removeSubscription(t);
  }
  removeAllSubscriptions() {
    this.Et.removeAllSubscriptions(), this.rh.removeAllSubscriptions();
  }
  closeMessage() {
    this.Ae(this.Me);
  }
  ze() {
    return !0;
  }
  do() {
    return this.ze();
  }
  xe() {
    return null != this.htmlId && this.htmlId.length > 4;
  }
  Ce() {
    return this.xe() && null != this.css && this.css.length > 0;
  }
  ve() {
    if (this.xe() && this.Ce()) return this.htmlId + "-css";
  }
  K() {
    return !this.Th && ((this.Th = !0), !0);
  }
  Ur() {
    return this.Th;
  }
  p(t) {
    return !this.vo && ((this.vo = !0), this.Et.Dt(), !0);
  }
  N() {
    return !this.oh && ((this.oh = !0), this.rh.Dt(), !0);
  }
  hide(t) {
    if (t && t.parentNode) {
      let s = t.closest(".ab-iam-root");
      if ((null == s && (s = t), this.ze() && null != s.parentNode)) {
        const t = s.parentNode.classList;
        t && t.contains(InAppMessage.lh) && t.remove(InAppMessage.lh),
          document.body.removeEventListener("touchmove", InAppMessage.uh);
      }
      s.className = s.className.replace(InAppMessage.ah, InAppMessage.Ih);
    }
    return this.animateOut || !1;
  }
  Ae(t, s) {
    if (null == t) return;
    let i;
    (this.Me = null),
      (i =
        -1 === t.className.indexOf("ab-in-app-message")
          ? t.getElementsByClassName("ab-in-app-message")[0]
          : t);
    let h = !1;
    i && (h = this.hide(i));
    const e = document.body;
    let E;
    null != e && (E = e.scrollTop);
    const n = () => {
      if (t && t.parentNode) {
        let s = t.closest(".ab-iam-root");
        null == s && (s = t), s.parentNode && s.parentNode.removeChild(s);
      }
      const i = this.ve();
      if (null != i) {
        const t = document.getElementById(i);
        t && t.parentNode && t.parentNode.removeChild(t);
      }
      null != e && "Safari" === X.browser && (e.scrollTop = E),
        s ? s() : this.N();
    };
    h ? setTimeout(n, InAppMessage.Ah) : n(), this.ke && this.ke.focus();
  }
  Je() {
    return document.createTextNode(this.message || "");
  }
  Ge(t) {
    let s = "";
    this.message || this.header || !this.ze() || (s = "Modal Image"),
      t.setAttribute("alt", s);
  }
  static uh(t) {
    if (t.targetTouches && t.targetTouches.length > 1) return;
    const s = t.target;
    (s &&
      s.classList &&
      s.classList.contains("ab-message-text") &&
      s.scrollHeight > s.clientHeight) ||
      (document.querySelector(`.${InAppMessage.lh}`) &&
        t.cancelable &&
        t.preventDefault());
  }
  Oh(t) {
    const s = t.parentNode;
    this.ze() &&
      null != s &&
      this.orientation !== InAppMessage.Orientation.LANDSCAPE &&
      (null != s.classList && s.classList.add(InAppMessage.lh),
      document.body.addEventListener(
        "touchmove",
        InAppMessage.uh,
        !!Tt() && { passive: !1 },
      )),
      (t.className += " " + InAppMessage.ah);
  }
  static _h(t) {
    if (
      t.keyCode === lt.mh &&
      !e.nn(L.Lh) &&
      document.querySelectorAll(".ab-modal-interactions").length > 0
    ) {
      const t = document.getElementsByClassName("ab-html-message");
      let s = !1;
      for (const i of t) {
        let t = null;
        It(i) &&
          i.contentWindow &&
          (t = i.contentWindow.document.getElementsByClassName(
            "ab-programmatic-close-button",
          )[0]),
          null != t && (Et(t), (s = !0));
      }
      if (!s) {
        const t = document.querySelectorAll(
          ".ab-modal-interactions > .ab-close-button",
        )[0];
        null != t && Et(t);
      }
    }
  }
  Nh() {
    this.nh ||
      e.nn(L.Lh) ||
      (document.addEventListener("keydown", InAppMessage._h, !1),
      e.Sh(() => {
        document.removeEventListener("keydown", InAppMessage._h);
      }),
      (this.nh = !0));
  }
  Y(t) {
    const s = {};
    return t
      ? ((s[InAppMessage.tt.Vr] = this.message),
        (s[InAppMessage.tt.Wr] = this.messageAlignment),
        (s[InAppMessage.tt.Rh] = this.slideFrom),
        (s[InAppMessage.tt.bt] = this.extras),
        (s[InAppMessage.tt.Yr] = this.triggerId),
        (s[InAppMessage.tt.Zr] = this.clickAction),
        (s[InAppMessage.tt.URI] = this.uri),
        (s[InAppMessage.tt.ea] = this.openTarget),
        (s[InAppMessage.tt.ra] = this.dismissType),
        (s[InAppMessage.tt.sa] = this.duration),
        (s[InAppMessage.tt.ta] = this.icon),
        (s[InAppMessage.tt.ot] = this.imageUrl),
        (s[InAppMessage.tt.ia] = this.imageStyle),
        (s[InAppMessage.tt.aa] = this.iconColor),
        (s[InAppMessage.tt.oa] = this.iconBackgroundColor),
        (s[InAppMessage.tt.pa] = this.backgroundColor),
        (s[InAppMessage.tt.ma] = this.textColor),
        (s[InAppMessage.tt.na] = this.closeButtonColor),
        (s[InAppMessage.tt.ua] = this.animateIn),
        (s[InAppMessage.tt.ca] = this.animateOut),
        (s[InAppMessage.tt.fa] = this.header),
        (s[InAppMessage.tt.da] = this.headerAlignment),
        (s[InAppMessage.tt.la] = this.headerTextColor),
        (s[InAppMessage.tt.ga] = this.frameColor),
        (s[InAppMessage.tt.ja] = this.buttons),
        (s[InAppMessage.tt.xa] = this.cropType),
        (s[InAppMessage.tt.za] = this.orientation),
        (s[InAppMessage.tt.ha] = this.htmlId),
        (s[InAppMessage.tt.CSS] = this.css),
        (s[InAppMessage.tt.Z] = t),
        (s[InAppMessage.tt.va] = this.messageExtras),
        s)
      : s;
  }
}
(InAppMessage.th = {
  hh: 4281545523,
  ih: 4294967295,
  sh: 4278219733,
  Mh: 4293914607,
  Dh: 4283782485,
  Eh: 3224580915,
  eh: 4288387995,
}),
  (InAppMessage.Be = {
    Ch: "hd",
    Le: "ias",
    dh: "of",
    Uh: "do",
    bh: "umt",
    Ph: "tf",
    ph: "te",
  }),
  (InAppMessage.SlideFrom = { TOP: "TOP", BOTTOM: "BOTTOM" }),
  (InAppMessage.ClickAction = {
    NEWS_FEED: "NEWS_FEED",
    URI: "URI",
    NONE: "NONE",
  }),
  (InAppMessage.DismissType = {
    AUTO_DISMISS: "AUTO_DISMISS",
    MANUAL: "SWIPE",
  }),
  (InAppMessage.OpenTarget = { NONE: "NONE", BLANK: "BLANK" }),
  (InAppMessage.ImageStyle = { TOP: "TOP", GRAPHIC: "GRAPHIC" }),
  (InAppMessage.Orientation = { PORTRAIT: "PORTRAIT", LANDSCAPE: "LANDSCAPE" }),
  (InAppMessage.TextAlignment = {
    START: "START",
    CENTER: "CENTER",
    END: "END",
  }),
  (InAppMessage.CropType = {
    CENTER_CROP: "CENTER_CROP",
    FIT_CENTER: "FIT_CENTER",
  }),
  (InAppMessage.qe = {
    Kr: "SLIDEUP",
    Jr: "MODAL",
    Ve: "MODAL_STYLED",
    Or: "FULL",
    Hr: "WEB_HTML",
    $e: "HTML",
    We: "HTML_FULL",
  }),
  (InAppMessage.Ah = 500),
  (InAppMessage.fh = 200),
  (InAppMessage.ah = "ab-show"),
  (InAppMessage.Ih = "ab-hide"),
  (InAppMessage.lh = "ab-pause-scrolling"),
  (InAppMessage.tt = {
    Vr: "m",
    Wr: "ma",
    Rh: "sf",
    bt: "e",
    Yr: "ti",
    Zr: "ca",
    URI: "u",
    ea: "oa",
    ra: "dt",
    sa: "d",
    ta: "i",
    ot: "iu",
    ia: "is",
    aa: "ic",
    oa: "ibc",
    pa: "bc",
    ma: "tc",
    na: "cbc",
    ua: "ai",
    ca: "ao",
    fa: "h",
    da: "ha",
    la: "htc",
    ga: "fc",
    ja: "b",
    xa: "ct",
    za: "o",
    ha: "hi",
    CSS: "css",
    Z: "type",
    uo: "messageFields",
    va: "me",
  });
